import React, { useEffect } from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import * as Sentry from '@sentry/react';

/**
 * createBrowserRouter 의 errorElement.
 * 라우트 컴포넌트의 렌더 단계 크래시는 React Router 가 가로채 이 컴포넌트를 띄우는데,
 * 기존 NotFound 는 Sentry 로 보고하지 않아 "흰 화면 / 빈 화면" 류 에러가 전부 누락됐다.
 * 여기서 실제 크래시만 captureException 으로 보고한다(로그인 계정 스코프 포함).
 */
export default function RouteError() {
  const error = useRouteError();

  // 404 등 정상적인 라우트 응답(isRouteErrorResponse)은 보고하지 않는다.
  const isRouteResponse = isRouteErrorResponse(error);

  useEffect(() => {
    if (!isRouteResponse) {
      Sentry.captureException(error, (scope) => {
        scope.setTag('error.category', '화면 깨짐 / 빈 화면');
        return scope;
      });
    }
  }, [error, isRouteResponse]);

  if (isRouteResponse && error.status === 404) {
    return (
      <div className='flex justify-center items-center h-screen'>
        <div>Not Found This Page 🤔</div>
      </div>
    );
  }

  const reload = async () => {
    // reload 로 전송 중이던 이벤트가 끊기지 않도록 flush 후 새로고침
    try { await Sentry.flush(2000); } catch {}
    window.location.reload();
  };

  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <h2>일시적인 오류가 발생했습니다</h2>
      <p>잠시 후 다시 시도해 주세요.</p>
      <button onClick={reload} style={{ padding: '8px 16px', marginTop: 12 }}>
        새로고침
      </button>
    </div>
  );
}
